import { useSkaldElements } from '@skaldaura/devkit'
import Modal from 'components/modal/modal'
import SubgroupPopup from 'components/popupDocuments/subelementPopup'
import AnchorButtonContext from 'contexts/anchorButton'
import { useCounterContext } from 'contexts/counter'
import HeadbandContext from 'contexts/headband'
import { useContext, useEffect, useState } from 'react'
import { getItem } from 'store/localeStorage'
import { IPDF } from './projets'

export default function Archives() {
   const { setCounter, counterDefault } = useCounterContext()
   const { setHeadband } = useContext(HeadbandContext)
   const { setAnchorButton } = useContext(AnchorButtonContext)
   const [stepElement] = useSkaldElements(`${getItem('totem')} : Archives`)
   const [pdfs, setPdfs] = useState<IPDF[]>([])
   const [selectedPdf, setSelectedPdf] = useState<IPDF>(pdfs[0])
   const [isOpen, setIsOpen] = useState(false)

   useEffect(() => {
      setCounter(counterDefault)
      setHeadband('BE LEAN +')
      setAnchorButton([])
   }, [])

   useEffect(() => {
      if (stepElement[0]) {
         stepElement[0].getPopulatedSubgroups().then((pdfs: IPDF[]) => setPdfs([...pdfs]))
      }
   }, [stepElement])

   const handleOpen = (subgroup: IPDF) => {
      setSelectedPdf(subgroup)
      setIsOpen(true)
   }

   return (
      <div className='h-full overflow-x-scroll w-[920px]'>
         <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
            <SubgroupPopup pdf={selectedPdf} />
         </Modal>
         <div className='flex flex-row flex-wrap p-2'>
            {pdfs.map((pdf: IPDF, index) => {
               return (
                  <img
                     className='w-[300px] border-black border-[1px]'
                     key={index}
                     src={pdf.pages[0] && pdf.pages[0].value}
                     onClick={() => handleOpen(pdf)}
                  />
               )
            })}
         </div>
      </div>
   )
}
